import { User, FileText, Edit, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PersonalInfo } from '@/types';
import { API_CONFIG } from '@/config';

interface ProfileCardProps {
  profile: PersonalInfo;
  isAdmin: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export function ProfileCard({ profile, isAdmin, onEdit, onDelete }: ProfileCardProps) {
  const handleResumeClick = () => {
    if (profile.resumeUrl) {
      window.open(profile.resumeUrl ? API_CONFIG.BASE_URL + "/" + profile.resumeUrl : "", '_blank');
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-200">
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-48 h-48 md:h-auto flex-shrink-0">
          {profile.photoUrl ? (
            <img
              src={profile.photoUrl ? API_CONFIG.BASE_URL + "/" + profile.photoUrl : ""}
              alt={profile.fullName}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-gray-100 flex items-center justify-center">
              <User className="w-16 h-16 text-gray-400" />
            </div>
          )}
        </div>

        <div className="flex-1 p-6">
          <div className="flex flex-col md:flex-row justify-between">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {profile.fullName}
              </h3>
              <p className="text-gray-600 mb-4 max-w-2xl">
                {profile.description}
              </p>
            </div>

            <div className="mt-4 md:mt-0 md:mr-6 flex md:flex-col justify-start gap-2">
              {profile.resumeUrl && (
                <Button
                  variant="outline"
                  className="hover:bg-secondary hover:text-white"
                  onClick={handleResumeClick}
                >
                  <FileText className="h-4 w-4 ml-2" />
                  السيرة الذاتية
                </Button>
              )}

              {isAdmin && (
                <div className="flex gap-2 md:flex-col">
                  <Button
                    variant="outline"
                    className="hover:bg-secondary hover:text-white"
                    onClick={onEdit}
                  >
                    <Edit className="h-4 w-4 ml-2" />
                    تعديل
                  </Button>
                  <Button
                    variant="ghost"
                    className="text-red-600 hover:text-red-700 hover:bg-red-50"
                    onClick={onDelete}
                  >
                    <Trash2 className="h-4 w-4 ml-2" />
                    حذف
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}